import React, { Component } from "react";
import ProductsContainer from "../../containers/products/index";
import ProductContainer from "../../containers/products/Product";
import { useParams } from "react-router-dom";

const ProductsPage = () => {
  let { id } = useParams();

  return id ? <ProductContainer id={id} /> : <ProductsContainer />;
};

export default ProductsPage;
